import chartMetaDataTransformer from "../transformers/chart-meta-data";
import scatterPlotIconActive from "../../assets/images/ic_scatter_blue.png";
import scatterPlotIconInactive from "../../assets/images/ic_scatter_grey.png";
import lineIconActive from "../../assets/images/ic_line_blue.png";
import lineIconInactive from "../../assets/images/ic_line_grey.png";
import histogramIconActive from "../../assets/images/ic_histogram_blue.png";
import histogramIconInactive from "../../assets/images/ic_histogram_grey.png";
import areaMirroredIconActive from "../../assets/images/ic_area_mirror_blue.png";
import areaMirroredIconInactive from "../../assets/images/ic_area_mirror_grey.png";
import {
  TOOLTIP_CTT,
  TOOLTIP_SPREAD,
  TOOLTIP_BID_ASK_QUANTITY,
  TOOLTIP_GRANULARITY_DAY,
  TOOLTIP_GRANULARITY_WEEK,
  TOOLTIP_GRANULARITY_MONTH,
  TOOLTIP_GRANULARITY_QUARTER,
  TOOLTIP_GRANULARITY_YEAR,
  TOOLTIP_LAYER_BUY,
  TOOLTIP_LAYER_SELL,
  TOOLTIP_LAYER_TREND_LINES,
  TOOLTIP_LAYER_MID_PRICE,
  TOOLTIP_LAYER_TOPOFTHEBOOK,
  TOOLTIP_LAYER_TOP3LEVELS,
  TOOLTIP_LAYER_TOP5LEVELS,
  TOOLTIP_LAYER_TOP10LEVELS
} from "./string-literals";

// Formats

export const DATE_FORMAT = "MMM DD, YYYY";
export const DATETIME_FORMAT = "MMM DD, YYYY hh:mm:ss A Z";
export const DATETIME_NO_OFFSET_FORMAT = "MMM DD, YYYY hh:mm:ss A";
export const DATE_MONTH_YEAR_FORMAT = "MMM, YYYY";
export const DATE_YEAR_FORMAT = "YYYY";

// Form Controls

export const SELECT_EMPTY_VALUE = "-1";

// Keys

export const STORAGE_KEY_APP_DATA = "__App_Cached_Data";
export const STORAGE_KEY_WHITEBOARD_DATA = "__Whiteboard_Cached_Data";
export const STORAGE_KEY_USER_INFO = "__User_Info";
export const STORAGE_KEY_HOLIDAYS = "__Holidays";
export const STORAGE_KEY_HOLIDAYSTITLE = "__Holidays_Title";

// Trading Hours

export const TRADING_HOUR_REGULAR = "RTH";
export const TRADING_HOUR_EXTENDED = "ETH";
export const TRADING_HOURS = [
  { Code: TRADING_HOUR_REGULAR, Name: "Regular Trading Hours" },
  { Code: TRADING_HOUR_EXTENDED, Name: "Extended Trading Hours" }
];

// Time Zones

export const ZONE_CH = "CH";
export const ZONE_LN = "LN";
export const ZONE_SG = "SG";
export const ZONES = [
  { Code: ZONE_CH, Name: "Chicago", Offset: "-06:00", Timing: "7:00 AM to 4:00 PM" },
  { Code: ZONE_LN, Name: "London", Offset: "+00:00", Timing: "07:00 AM to 05:00 PM" },
  { Code: ZONE_SG, Name: "Singapore", Offset: "+08:00", Timing: "08:00 AM to 08:00 PM" }
];

// Charts

export const CHART_SPREAD = "SPREAD";
export const CHART_CTT = "COST_TO_TRADE";
export const CHART_BID_ASK_QUANTITY = "BID_ASK_QUANTITY";
export const CHARTS = [
  { Code: CHART_CTT, Name: "Cost To Trade", Tooltip: TOOLTIP_CTT, FixDecimalPointsTo: 2, DisplayTickSizeValue: true },
  { Code: CHART_SPREAD, Name: "Bid Ask Spread", Tooltip: TOOLTIP_SPREAD, FixDecimalPointsTo: 2, DisplayTickSizeValue: true },
  { Code: CHART_BID_ASK_QUANTITY, Name: "Book Depth", Tooltip: TOOLTIP_BID_ASK_QUANTITY, FixDecimalPointsTo: 1, DisplayTickSizeValue: false }
];

// Note: Bid Ask Quantity chart was later renamed to Book Depth chart

// Chart Types

export const CHART_TYPE_SCATTER_PLOT = "SCATTER_PLOT";
export const CHART_TYPE_LINE = "LINE";
export const CHART_TYPE_HISTOGRAM = "HISTOGRAM";
export const CHART_TYPE_AREA_MIRRORED = "AREA_MIRRORED";
export const CHARTS_TYPES = [
  { Code: CHART_TYPE_SCATTER_PLOT, Name: "Scatter Plot Chart", IconActive: scatterPlotIconActive, IconInactive: scatterPlotIconInactive },
  { Code: CHART_TYPE_LINE, Name: "Line Chart", IconActive: lineIconActive, IconInactive: lineIconInactive },
  { Code: CHART_TYPE_HISTOGRAM, Name: "Histogram Chart", IconActive: histogramIconActive, IconInactive: histogramIconInactive },
  { Code: CHART_TYPE_AREA_MIRRORED, Name: "Area Chart (Mirrored)", IconActive: areaMirroredIconActive, IconInactive: areaMirroredIconInactive }
];

// Charts And Types Mapping
// Ex: 'Spread Analysis' is mapped to 'Line Chart' and 'Histogram Chart'

export const CHARTS_AND_TYPES_MAPPING = {
  [CHART_CTT]: [CHART_TYPE_SCATTER_PLOT],
  [CHART_SPREAD]: [CHART_TYPE_LINE],
  [CHART_BID_ASK_QUANTITY]: [CHART_TYPE_AREA_MIRRORED]
};

// Chart Layers

export const CHART_LAYER_BID = "CHART_LAYER_BID";
export const CHART_LAYER_ASK = "CHART_LAYER_ASK";
export const CHART_LAYER_MID_PRICE = "CHART_LAYER_MID_PRICE";
export const CHART_LAYER_TREND_LINES = "CHART_LAYER_TREND_LINES";
export const CHART_LAYER_LEVELS_TOP = "CHART_LAYER_LEVELS_TOP";
export const CHART_LAYER_LEVELS_TOP_3 = "CHART_LAYER_LEVELS_TOP_3";
export const CHART_LAYER_LEVELS_TOP_5 = "CHART_LAYER_LEVELS_TOP_5";
export const CHART_LAYER_LEVELS_TOP_10 = "CHART_LAYER_LEVELS_TOP_10";
export const CHART_LAYERS = [
  { Code: CHART_LAYER_BID, Name: "Buy", Tooltip: TOOLTIP_LAYER_BUY },
  { Code: CHART_LAYER_ASK, Name: "Sell", Tooltip: TOOLTIP_LAYER_SELL },
  { Code: CHART_LAYER_MID_PRICE, Name: "Mid Price", Tooltip: TOOLTIP_LAYER_MID_PRICE },
  { Code: CHART_LAYER_TREND_LINES, Name: "Trend Lines", Tooltip: TOOLTIP_LAYER_TREND_LINES },
  { Code: CHART_LAYER_LEVELS_TOP, Name: "Top Of The Book", Tooltip: TOOLTIP_LAYER_TOPOFTHEBOOK },
  { Code: CHART_LAYER_LEVELS_TOP_3, Name: "Top 3 Levels", Tooltip: TOOLTIP_LAYER_TOP3LEVELS },
  { Code: CHART_LAYER_LEVELS_TOP_5, Name: "Top 5 Levels", Tooltip: TOOLTIP_LAYER_TOP5LEVELS },
  { Code: CHART_LAYER_LEVELS_TOP_10, Name: "Top 10 Levels", Tooltip: TOOLTIP_LAYER_TOP10LEVELS }
];

// Charts Overlay Combinations

export const CHARTS_OVERLAY_COMBO = [
  { Chart: CHART_CTT, Combo: [CHART_SPREAD, CHART_BID_ASK_QUANTITY] },
  { Chart: CHART_SPREAD, Combo: [CHART_CTT, CHART_BID_ASK_QUANTITY] },
  { Chart: CHART_BID_ASK_QUANTITY, Combo: [CHART_CTT, CHART_SPREAD] }
];

// Charts + Types + Layers Mapping
// Ex: 'Spread Analysis' 'Line Chart' will have
// 'Mid Price', 'Top Of The Book', 'Top 3 Levels', 'Top 5 Levels', 'Top 10 Levels layers'

export const CHARTS_AND_TYPES_AND_LAYERS_MAPPING = [
  {
    // Cost To Trade (Scatter)
    Chart: CHART_CTT,
    Type: CHART_TYPE_SCATTER_PLOT,
    Checkboxes: [CHART_LAYER_BID, CHART_LAYER_ASK, CHART_LAYER_MID_PRICE, CHART_LAYER_TREND_LINES]
  },
  {
    // Spread (Line)
    Chart: CHART_SPREAD,
    Type: CHART_TYPE_LINE,
    Checkboxes: [CHART_LAYER_MID_PRICE],
    Dropdown: [CHART_LAYER_LEVELS_TOP, CHART_LAYER_LEVELS_TOP_3, CHART_LAYER_LEVELS_TOP_5, CHART_LAYER_LEVELS_TOP_10]
  },
  {
    // Bid Ask Quantity (Area)
    Chart: CHART_BID_ASK_QUANTITY,
    Type: CHART_TYPE_AREA_MIRRORED,
    Checkboxes: [CHART_LAYER_MID_PRICE],
    Dropdown: [CHART_LAYER_LEVELS_TOP, CHART_LAYER_LEVELS_TOP_3, CHART_LAYER_LEVELS_TOP_5, CHART_LAYER_LEVELS_TOP_10]
  },
  {
    // Cost To Trade (Scatter) + Spread (Line)
    Chart: CHART_CTT,
    Type: CHART_TYPE_SCATTER_PLOT,
    OverlayChart: CHART_SPREAD,
    OverlayType: CHART_TYPE_LINE,
    Checkboxes: [CHART_LAYER_BID, CHART_LAYER_ASK, CHART_LAYER_TREND_LINES],
    Dropdown: [CHART_LAYER_LEVELS_TOP]
  },
  {
    // Cost To Trade (Scatter) + Bid Ask Quantity (Area)
    Chart: CHART_CTT,
    Type: CHART_TYPE_SCATTER_PLOT,
    OverlayChart: CHART_BID_ASK_QUANTITY,
    OverlayType: CHART_TYPE_AREA_MIRRORED,
    Checkboxes: [CHART_LAYER_BID, CHART_LAYER_ASK, CHART_LAYER_TREND_LINES],
    Dropdown: [CHART_LAYER_LEVELS_TOP]
  },
  {
    // Spread (Line) + Bid Ask Quantity (Area)
    Chart: CHART_SPREAD,
    Type: CHART_TYPE_LINE,
    OverlayChart: CHART_BID_ASK_QUANTITY,
    OverlayType: CHART_TYPE_AREA_MIRRORED,
    Dropdown: [CHART_LAYER_LEVELS_TOP]
  }
];

// Granularities

export const GRANULARITY_DAY = "D";
export const GRANULARITY_WEEK = "W";
export const GRANULARITY_MONTH = "MO";
export const GRANULARITY_QUARTER = "Q";
export const GRANULARITY_YEAR = "Y";
export const GRANULARITIES = [
  { Code: GRANULARITY_DAY, Name: "1D", Tooltip: TOOLTIP_GRANULARITY_DAY, TickFormat: "%d %b" },
  { Code: GRANULARITY_WEEK, Name: "1W", Tooltip: TOOLTIP_GRANULARITY_WEEK, TickFormat: "%d %b" },
  { Code: GRANULARITY_MONTH, Name: "1M", Tooltip: TOOLTIP_GRANULARITY_MONTH, TickFormat: "%b %Y" },
  { Code: GRANULARITY_QUARTER, Name: "1Q", Tooltip: TOOLTIP_GRANULARITY_QUARTER, TickFormat: "%b %Y" },
  { Code: GRANULARITY_YEAR, Name: "1Y", Tooltip: TOOLTIP_GRANULARITY_YEAR, TickFormat: "%Y" }
];

// Cost To Trade Lot Sizes

export const COST_TO_TRADE_LOT_SIZES_MIN_LIMIT = 1;
export const COST_TO_TRADE_LOT_SIZES_MAX_LIMIT = 4;

// Initial Chart Drawing State

export const CHART_DRAWING_INITIAL_STATE = {
  // Unique identifier for this Drawing
  __id: undefined,
  // Key used to identify changes in this Drawing
  __change_detection_key: undefined
};

// Initial Chart Whiteboard State

export const WHITEBOARD_INITIAL_STATE = {
  // Unique identifier for this Whiteboard
  __id: undefined,
  // Key used to identify changes in this Whiteboard
  __change_detection_key: undefined,
  // List of Primary Charts for this Whiteboard
  // Ex: Spread, Cost To Trade, Bid Ask Quantity
  primaryCharts: CHARTS,
  // Selected Primary Chart for this Whiteboard
  selectedPrimaryChart: CHART_CTT,
  // List of Primary Chart Types for this Whiteboard
  // Ex: Line, Scatter Plot, Histogram
  primaryChartTypes: chartMetaDataTransformer.getApplicableChartTypesByChart(CHART_CTT),
  // Selected Primary Chart Type for this Whiteboard
  selectedPrimaryChartType: CHART_TYPE_SCATTER_PLOT,
  // List of Comparison Charts for this Whiteboard
  // Ex: Spread, Cost To Trade, Bid Ask Quantity
  comparisonCharts: chartMetaDataTransformer.getApplicableComparisonChartsByPrimaryChart(CHART_CTT),
  // Selected Comparison Chart for this Whiteboard
  selectedComparisonChart: SELECT_EMPTY_VALUE,
  // List of Primary Chart Types for this Whiteboard
  // Ex: Line, Scatter Plot, Histogram
  comparisonChartTypes: [],
  // Selected Comparison Chart Type for this Whiteboard
  selectedComparisonChartType: undefined,
  // List of Granularities for this Whiteboard
  granularities: GRANULARITIES,
  // Selected Granularity for this Whiteboard
  selectedGranularity: GRANULARITY_DAY,
  // Selected CTT Lot Sizes for this Whiteboard
  // Note: Applicable Cost To Trade only
  selectedCostToTradeLotSizes: [],
  // Selected Chart Layers for this Whiteboard
  selectedLayers: chartMetaDataTransformer.getApplicableChartLayers(CHART_CTT, CHART_TYPE_SCATTER_PLOT).selectiveLayers,
  // Multiple Chart Drawings under a Whiteboard, especially in case of Cost To Trade
  chartDrawings: [],
  // Is this Whiteboard obsolete based on currently selected Filter options?
  isObsolete: false,
  isExcludeHolidays: false
};

export const WHITEBOARDS_MAX_LIMIT = 2;

// API Signature Keys

export const API_KEY_TIMESTAMP = "TS";
export const API_KEY_CONTRACT = "CT";
export const API_KEY_MID_PRICE = "MP";
export const API_KEY_WEIGHTAGE = "WT";

export const API_KEYS_CTT = {
  timestamp: API_KEY_TIMESTAMP,
  contract: API_KEY_CONTRACT,
  midPrice: API_KEY_MID_PRICE,
  bid: "B",
  ask: "S",
  bidDepth: "BDep",
  askDepth: "SDep"
};

export const API_KEYS_SPREAD = {
  timestamp: API_KEY_TIMESTAMP,
  contract: API_KEY_CONTRACT,
  midPrice: API_KEY_MID_PRICE,
  l1: "LVL1",
  l2: "LVL2",
  l3: "LVL3",
  l4: "LVL4",
  l5: "LVL5",
  l6: "LVL6",
  l7: "LVL7",
  l8: "LVL8",
  l9: "LVL9",
  l10: "LVL10"
};

export const API_KEYS_BID_ASK_QUANTITY = {
  timestamp: API_KEY_TIMESTAMP,
  contract: API_KEY_CONTRACT,
  midPrice: API_KEY_MID_PRICE,
  l1Ask: "LVL1A",
  l1Bid: "LVL1B",
  l2Ask: "LVL2A",
  l2Bid: "LVL2B",
  l3Ask: "LVL3A",
  l3Bid: "LVL3B",
  l4Ask: "LVL4A",
  l4Bid: "LVL4B",
  l5Ask: "LVL5A",
  l5Bid: "LVL5B",
  l6Ask: "LVL6A",
  l6Bid: "LVL6B",
  l7Ask: "LVL7A",
  l7Bid: "LVL7B",
  l8Ask: "LVL8A",
  l8Bid: "LVL8B",
  l9Ask: "LVL9A",
  l9Bid: "LVL9B",
  l10Ask: "LVL10A",
  l10Bid: "LVL10B"
};

// Chart Rendering

export const CHART_POINT_RADIUS = 2.5;
export const CHART_FOCUS_POINT_RADIUS = 4;

// Help Page

export const HELP_IMG_HOST_URL = "{HELP_IMG_HOST_URL}";

// Tick size values of products
export const PRODUCTS=[
  {
    productCode: 'ES',
    tickSizeValue: '1 tick = 0.25 index points=$12.50'
  },
  {
    productCode: 'ZT',
    tickSizeValue: '1 tick = (1/4)(1/32) of one point ($7.8125, rounded to the nearest cent per contract). From Jan 14th 2019 displayed as 0.5 tick [(1/8)(1/32)]'
  },
  {
    productCode: 'ZF',
    tickSizeValue: '1 tick = (1/4)(1/32) of one point ($7.8125, rounded to the nearest cent per contract)'
  },
  {
    productCode: 'ZN',
    tickSizeValue: '1 tick = One-half of one thirty-second (1/32) of one point = $15.625'
  },
  {
    productCode: 'TN',
    tickSizeValue: '1 tick = (1/2) (1/32) of one point ($15.625, rounded to the nearest cent per contract)'
  },
  {
    productCode: 'ZB',
    tickSizeValue: '1 tick = (1/32) of one point ($31.25)'
  },
  {
    productCode: 'UB',
    tickSizeValue: '1 tick = (1/32) of one point ($31.25)'
  },
  {
    productCode: 'NQ',
    tickSizeValue: '1 tick = 0.25 Index Points=$5.00'
  },
  {
    productCode: '6E',
    tickSizeValue: '1 tick = .00005 USD per EUR increments ($6.25 USD)'
  },
  {
    productCode: 'CL',
    tickSizeValue: '1 tick = $0.01 per Barrel = $10 (1000 Barrels per contract)'
  },
  {
    productCode: 'NG',
    tickSizeValue: '1 tick = $0.001 per MMBtu = $10 (10,000 MMBtu per contract)'
  },
  {
    productCode : 'RB',
    tickSizeValue: '1 tick = $0.0001 per gallon = $4.20 (42,000 gallons per contract)'
  },
  {
    productCode: 'HO',
    tickSizeValue: '1 tick = $0.0001 per gallon = $4.20 (42,000 gallons per contract)'
  },
  {
    productCode: 'GC',
    tickSizeValue: '1 tick = 0.10 per troy ounce = $10.00'
  },
  {
    productCode: 'ZC',
    tickSizeValue: '1 tick = 1/4 of one cent per bushel ($12.50 per contract)'
  },
  {
    productCode: 'ZS',
    tickSizeValue: '1 tick = 1/4 of one cent per bushel ($12.50 per contract)'
  },
  {
    productCode: 'ZW',
    tickSizeValue: '1 tick = 1/4 of one cent per bushel ($12.50 per contract)'
  },
  {
    productCode: 'ZL',
    tickSizeValue: '1 tick = 1/100 of a cent ($0.0001) per pound ($6.00 per contract)'
  },
  {
    productCode: 'LE',
    tickSizeValue: '1 tick = $.00025 per pound (=$10 per contract)'
  },
  {
    productCode: '6A',
    tickSizeValue: '1 tick = 0.00005 USD per AUD increments ($5.00 USD). From Nov 23rd 2020 displayed as 0.5 tick'
  },
  {
    productCode: '6B',
    tickSizeValue: '1 tick = 0.0001 USD per GBP increments ($6.25 USD)'
  },
  {
    productCode: '6C',
    tickSizeValue: '1 tick = 0.00005 USD per CAD increment ($5.00 USD)'
  },
  {
    productCode: '6J',
    tickSizeValue: '1 tick =  0.0000005 per JPY increment = $6.25'
  },
  {
    productCode: '6L',
    tickSizeValue: '1 tick = .00005 per Brazilian real increments ($5.00/contract)'
  },
  {
    productCode: '6M',
    tickSizeValue: '1 tick = 0.00001 per Mexican peso increments ($5.00/contract)'
  },
  {
    productCode: '6N',
    tickSizeValue: '1 tick = 0.00005 per New Zealand dollar =$5.00. From Aug 16th 2021 displayed as 0.5 tick'
  },
  {
    productCode: '6R',
    tickSizeValue: '1 tick = 0.000005 per Ruble=$12.50'
  },
  {
    productCode: '6S',
    tickSizeValue: '1 tick = 0.0001 per CHF increment = $12.50'
  },
  {
    productCode: '6Z',
    tickSizeValue: '1 tick = 0.000025 per South African rand increment = $12.50'
  },
  {
    productCode: 'HG',
    tickSizeValue: '1 tick = 0.0005 per pound = $12.50'
  },
  {
    productCode: 'NIY',
    tickSizeValue: '1 tick = 5.00 index points=2,500 Yen'
  },
  {
    productCode: 'PA',
    tickSizeValue: '1 tick = 0.50 per troy ounce = $50.00'
  },
  {
    productCode: 'PL',
    tickSizeValue: '1 tick = 0.10 per troy ounce = $5.00'
  },
  {
    productCode: 'RTY',
    tickSizeValue: '1 tick = 0.10 index points = $5.00'
  },
  {
    productCode: 'SI',
    tickSizeValue: '1 tick = 0.005 per troy ounce = $25.00'
  },
  {
    productCode: 'SR1',
    tickSizeValue: '1 tick = 0.0025 IMM index points (¼ basis point per annum) = $10.4175'
  },
  {
    productCode: 'SR3',
    tickSizeValue: '1 tick = 0.0025 IMM Index points (¼ basis point per annum) = $6.25'
  },
  {
    productCode: 'YM',
    tickSizeValue: '1 tick = 1.00 index point = $5.00'
  },
  {
    productCode: '6Z',
    tickSizeValue: '1 tick = 0.000025 per South African rand increments ($12.50/contract)'
  },
  {
    productCode: 'ZM',
    tickSizeValue: '1 tick = 0.10 per short ton = $10.00'
  },
  {
    productCode: 'NKD',
    tickSizeValue: '1 tick = 5.00 per index point = $25.00'
  },
  {
    productCode: 'BTC',
    tickSizeValue: '1 tick = 1.00 per bitcoin = $5.00'
  },
  {
    productCode: 'HE',
    tickSizeValue: '1 tick = 0.00025 per pound = $10.00'
  },
  {
    productCode: 'KE',
    tickSizeValue: '1 tick = 0.0025 per bushel = $12.50'
  },
  {
    productCode: 'GF',
    tickSizeValue: '1 tick = 0.00025 per pound = $12.50'
  }

]



// WEBPACK FOOTER //
// ./src/services/managers/constants.js